import React, { Component } from 'react'
import Helmet from 'react-helmet'

import SectionApplySurvey from '@/section-apply-survey'
import GetStartedSteps from '@/section-apply-survey/get-started-steps'

import shareImg from './images/get_started.png'

class GetStarted extends Component {
  render() {

    return (
      <div>
        <Helmet>
          <title>Get started</title>
          <meta property="og:title" content="What happens when you contact Next Miss" />
          <meta property="og:description" content="We care about our clients' time and make sure we offer the most streamlined, transparent and predictable process possible." />
          <meta property="og:image" content={`https://nextmiss.com${shareImg}`} />
          <meta property="og:url" content="https://nextmiss.com/get_started/" />
          <meta property="og:image:alt" content="Get started - Next Miss" />
        </Helmet>
        <SectionApplySurvey />
        <GetStartedSteps />
      </div>
    )
  }
}

export default GetStarted


// WEBPACK FOOTER //
// ./src/pages/get_started.js